export const STAT_BG_COLORS = {
  green: ["from-green-500", "to-green-400"],
  purple: ["from-purple-500", "to-purple-400"],
  blue: ["from-blue-500", "to-blue-400"],
  indigo: ["from-indigo-500", "to-indigo-400"],
  yellow: ["from-yellow-500", "to-yellow-400"],
  pink: ["from-pink-500", "to-pink-400"],
}
export const STAT_BG_DIRECTIONS = {
  r: "bg-gradient-to-r",
  tr: "bg-gradient-to-tr",
  br: "bg-gradient-to-br",
  bl: "bg-gradient-to-bl",
  tl: "bg-gradient-to-tl",
}

const colorKeys = Object.keys(STAT_BG_COLORS)
const directionKeys = Object.keys(STAT_BG_DIRECTIONS)

export function randomStatColor() {
  const randomBgColorKey1 = colorKeys[Math.floor(Math.random() * colorKeys.length)] as keyof typeof STAT_BG_COLORS
  const randomBgColorKey2 = colorKeys[Math.floor(Math.random() * colorKeys.length)] as keyof typeof STAT_BG_COLORS
  const randomBgDirection = directionKeys[Math.floor(Math.random() * directionKeys.length)] as keyof typeof STAT_BG_DIRECTIONS

  const colorArray = STAT_BG_COLORS[randomBgColorKey1]
  const colorArray2 = STAT_BG_COLORS[randomBgColorKey2]
  const randomFromColor = colorArray[0]
  const randomToColor = colorArray2[1]

  return `${STAT_BG_DIRECTIONS[randomBgDirection]} ${randomFromColor} ${randomToColor}`
}
